export const downloadLink = (downloadUrl: string, filename: string) => {
  const link = window.document.createElement('a')
  window.document.body.appendChild(link)
  link.style.display = 'none'
  link.href = downloadUrl
  link.download = filename
  if (process.env.CYPRESS !== 'true') link.click()
}
